<template>
  <div>
    <loadingCube v-if="loading_order" :loadingMessage="'ORDER'"></loadingCube>
    <div v-else-if="!loading_order && !order_job" class="record">
      Order could not be found.
    </div>
    <div v-else class="record">
      <b-tabs v-model="order_tabIndex" pills vertical>
        <template v-slot:tabs-start>
          <div class="record_info">
            <h5 class="mb-0 b3_color text-uppercase">{{ order_job.order.order_type }} Order</h5>
            <h2 class="font-weight-bold bp_color mb-0">{{ order_job.order_ref }}</h2>
            <h5>{{ order_job.order.company.company_name }}</h5>
            <p class="b3_color"><i class="fas fa-user"></i>&nbsp;&nbsp; {{ order_job.order.consultant.first_name }} {{
              order_job.order.consultant.surname }}</p>
            <h4 class="font-weight-bold bp_color mb-0">{{ order_job.rel_order_position.job_title }}</h4>
            <p>{{ order_job.rel_order_location.job_address_full }}</p>
            <hr>
            <div class="order_ended mb-2" v-if="order_job.rel_order_progress.order_progress_status === 'Ended'">ORDER
              ENDED</div>
            <div class="order_signed" v-if="order_job.rel_order_progress.order_signed">SIGNED</div>
            <div class="order_unsigned" v-if="!order_job.rel_order_progress.order_signed">UNSIGNED</div>
            <div class="order_signed mt-2" style="cursor: pointer;" v-if="!order_job.rel_order_progress.order_signed"
              @click="resendOrder()">
              <span v-if="!resending" class="order_signed"><i class="fas fa-envelope"></i> RE-SEND ORDER</span>
              <span v-if="resending" class="order_signed">Sending order ...</span>
            </div>
            <hr v-if="check_expiring !== ''">
            <div v-if="check_expiring !== ''" :class="check_expiring">
              <span v-if="check_expiring === 'expired'">EXPIRED
                <br style="display: block;margin-top: -15px;line-height: 10px;content: '';">{{
                  order_job.rel_order_position.end_date | formatDate }}</span>
              <span v-if="check_expiring === 'expiring'">EXPIRING
                <br style="display: block;margin-top: -15px;line-height: 10px;content: '';">{{
                  order_job.rel_order_position.end_date | formatDate }}</span>
            </div>
            <hr class="mb-0">
          </div>
        </template>
        <div class="record_short_btns">
          <div class="row">
            <!--            <div class="col-6 text-left">-->
            <!--              <button @click="createEmail" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Send Email">-->
            <!--                <i class="fas fa-paper-plane"></i>&nbsp;Email-->
            <!--              </button>-->
            <!--              <button @click="createEvent" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Create Event">-->
            <!--                <i class="fas fa-calendar-plus"></i>&nbsp; Event-->
            <!--              </button>-->
            <!--              <button @click="createTask" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Create Task">-->
            <!--                <i class="fas fa-plus-square"></i>&nbsp;Task-->
            <!--              </button>-->
            <!--            </div>-->
            <div class="col-12">
              <button @click="copy_order" class="btn orcaBtn sm_btn indigoBtn mb-2 mr-1 ml-1" data-toggle="tooltip"
                title="Copy Order">
                <i class="fas fa-copy"></i> &nbsp;&nbsp; Copy Order
              </button>
              <!--              <button @click="delete_order" class="btn orcaBtn sm_btn danger mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Delete Order">-->
              <!--                <i class="fas fa-trash-alt"></i> &nbsp;&nbsp; Delete Order-->
              <!--              </button>-->
              <button v-if="order_job.rel_order_progress.order_progress_status !== 'Ended'" @click="end_order"
                class="btn orcaBtn sm_btn warning mb-2 mr-1 ml-1" data-toggle="tooltip" title="End Order">
                <i class="fas fa-stop"></i> &nbsp;&nbsp; End Order
              </button>
              <button @click="add_note_modal" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1" data-toggle="tooltip"
                title="Add Notes for Order job">
                <i class="fas fa-comment-dots"></i>&nbsp; Add note order job
              </button>

              <button @click="add_files_modal" class="btn orcaBtn sm_btn mb-2" data-toggle="tooltip"
                title="Add Document to Order job">
                <i class="fas fa-file-upload"></i> &nbsp; Add Document order job
              </button>
            </div>
          </div>
        </div>

        <!-- Order -->
        <b-tab title="Order" lazy>
          <!-- Basic Information -->
          <div class="row">
            <div class="col-12">
              <b-card header="Basic Information" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
                <div class="row">
                  <!-- Order Date -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="order_date">Order Date</label>
                    <p id="order_date">{{ order_job.order.date_of_order | formatDate }}</p>
                  </div>
                  <!-- Order Created -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="order_created">Order Created</label>
                    <p id="order_created">{{ order_job.created_at | formatDateTime }}</p>
                  </div>
                  <!-- Order Status -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="order_status">Order Status</label>
                    <p id="order_status">{{ order_job.rel_order_progress.order_progress_status }}</p>
                  </div>
                  <!-- GM Solution -->
                  <div class="col-xl-3 form-group" v-if="order_job.order.order_gm_solution">
                    <label class="form-label" for="order_gm_solution">Solution</label>
                    <p id="order_gm_solution">{{ order_job.order.order_gm_solution }}</p>
                  </div>
                  <!-- GM Project Manager -->
                  <div class="col-xl-3 offset-xl-9 form-group"
                    v-if="order_job.order.order_gm_solution === 'Project Managed Labour Solutions'">
                    <label class="form-label" for="order_gm_project_manager">Project Manger</label>
                    <p id="order_gm_project_manager">{{ order_job.order.project_manager.first_name }} {{
                      order_job.order.project_manager.surname }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4 form-group">
                    <label class="form-label" for="workers_required">Current End Date</label>
                    <p id="workers_required">{{ order_job.rel_order_position.end_date | formatDate }}</p>
                  </div>
                  <div class="form-group col-lg-4">
                    <label class="form-label" for="extendCcoDate">Extend CCO end date</label>
                    <datepicker v-model="extendCcoDate" id="extendCcoDate" name="extendCcoDate"
                      :input-class="['date-input']" :format="dateFormat" :use-utc="true"
                      clear-button-icon="far fa-calendar-times"></datepicker>
                  </div>
                  <div class="form-group col-lg-4">
                    <button class="btn orcaBtn sm_btn w-100 mt-2" @click.prevent="extend_cco_date()"
                      :disabled="extendingCcoDates">
                      <span v-if="extendingCcoDates"><i class="fas fa-spinner fa-spin"></i> Extending CCO Date</span>
                      <span v-else>Extend CCO Date</span>
                    </button>
                  </div>
                </div>

                <ValidationObserver ref="extendCcoWorkersForm" slim>
                  <form role="form" @submit.prevent="extend_cco_capacity" class="row">
                    <div class="col-lg-4 form-group">
                      <label class="form-label" for="workers_required">Currently assigned</label>
                      <p id="workers_required">{{ current_assignments.length }} of {{ order_job.workers_required }}</p>
                    </div>
                    <div class="col-lg-4 form-group">
                      <ValidationProvider :rules="'numeric|required|min_value:' + current_assignments.length"
                        v-slot="{ errors }">
                        <label class="form-label" for="workers_required">Extend Capacity to</label>
                        <input type="text" v-model="expandCcoCapcityNumber" id="workers_required"
                          name="workers_required" class="form-input" maxlength="255" :min="order_job.workers_required">
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div class="col-lg-4 form-group">
                      <button class="btn orcaBtn sm_btn w-100 mt-2" type="submit" :disabled="expandingCcoCapacity">
                        <span v-if="expandingCcoCapacity"><i class="fas fa-spinner fa-spin"></i> Expanding CCO
                          Capacity</span>
                        <span v-else>Expand CCO Capacity</span>
                      </button>
                    </div>
                  </form>
                </ValidationObserver>

              </b-card>
            </div>
          </div>
          <!-- JOB LOCATION -->
          <div class="row">
            <div class="col-12">
              <b-card header="Job Location" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
                <div class="row">
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="short_site_name">Short Location (Site) Name</label>
                    <p id="short_site_name">{{ order_job.rel_order_location.short_site_name }}</p>
                  </div>
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="job_address_full">Full Address for Location (Site)</label>
                    <p id="job_address_full">{{ order_job.rel_order_location.job_address_full }}</p>
                  </div>

                  <!-- if contract order -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="site_main_contractor">Site Main Contractor</label>
                    <p id="site_main_contractor">{{ order_job.rel_order_location.site_main_contractor }}</p>
                  </div>
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="site_vat_treatment">Site VAT Treatment</label>
                    <p id="site_vat_treatment">{{ order_job.rel_order_location.site_vat_treatment | percentage }}</p>
                  </div>
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="site_alt_address">Alternative address (nickname)</label>
                    <p v-if="order_job.rel_order_location.use_job_number" id="site_alt_address">{{
                      order_job.rel_order_location.customer_job_number }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <label class="form-label">Geo Tech</label>
                    <div class="mt-4">
                      <bootstrap-toggle v-model="geotech" name="epi_order_geotech" id="epi_order_geotech"
                        :options="{ on: 'Yes', off: 'No' }" />
                    </div>
                  </div>
                  <div v-if="show_project_managed_fields()" class="col-xl-6">
                    <label class="form-label">Reverse VAT Charge</label>
                    <div class="mt-4" v-if="order_job.rel_order_location.site_vat_treatment != 0">
                      <bootstrap-toggle v-model="reverse_charge" name="epi_order_reverse_charge"
                        id="epi_order_geotech_reverse_charge" :options="{ on: 'Yes', off: 'No' }" />
                    </div>
                    <div class="mt-4" v-else><strong>Revers charge not available for VAT 0%</strong></div>
                  </div>
                  <div class="mt-4" v-else><strong>Revers charge availbe for "Project Manage" clients only.</strong></div>
                </div>
              </b-card>
            </div>
          </div>
          <!-- CONTACTS -->
          <div class="row">
            <div class="col-12">
              <b-card header="Contacts" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
                <div class="row">
                  <!-- JOB CONTACT -->
                  <div class="col-xl-6">
                    <div class="ind_contact">
                      <h5 class="contact_header">JOB</h5>
                      <div class="ind_contact_details">
                        <p class="mb-0 pl-2 pt-0"><span style="font-weight: bold; font-size: 0.8rem;"
                            v-if="order_job.order.job_contact !== null">
                            {{ order_job.order.job_contact.person.first_name }} {{
                              order_job.order.job_contact.person.surname }}
                          </span></p>
                        <p class="mb-0 pl-2 pt-1" style="line-height: 15px;">
                          <span v-if="order_job.order.job_contact.work_landline !== null">
                            <i class="fas fa-phone-alt bp_color"></i>&nbsp; {{ order_job.order.job_contact.work_landline
                            }}
                          </span>
                          <span v-if="order_job.order.job_contact.work_mobile !== null">
                            <i class="fas fa-mobile-alt bp_color"></i>&nbsp; {{ order_job.order.job_contact.work_mobile
                            }}
                          </span>
                        </p>
                        <p class="mb-0 pl-2 pt-1" style="line-height: 15px;"><i class="fas fa-at bp_color"></i>&nbsp; {{
                          order_job.order.job_contact.work_email }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- REPORTS TO CONTACT -->
                  <div class="col-xl-6">
                    <div class="ind_contact">
                      <h5 class="contact_header">REP TO</h5>
                      <div class="ind_contact_details">
                        <p class="mb-0 pl-2 pt-0"><span style="font-weight: bold; font-size: 0.8rem;"
                            v-if="order_job.rel_order_position.reports_to_contact !== null">
                            {{ order_job.rel_order_position.reports_to_contact.person.first_name }} {{
                              order_job.rel_order_position.reports_to_contact.person.surname }}
                          </span></p>
                        <p class="mb-0 pl-2 pt-1" style="line-height: 15px;">
                          <span v-if="order_job.rel_order_position.reports_to_contact.work_landline !== null">
                            <i class="fas fa-phone-alt bp_color"></i>&nbsp;{{
                              order_job.rel_order_position.reports_to_contact.work_landline }}
                          </span>
                          <span v-if="order_job.rel_order_position.reports_to_contact.work_mobile !== null">
                            <i class="fas fa-mobile-alt bp_color"></i>&nbsp;{{
                              order_job.rel_order_position.reports_to_contact.work_mobile }}
                          </span>
                        </p>
                        <p class="mb-0 pl-2 pt-1" style="line-height: 15px;"><i class="fas fa-at bp_color"></i>&nbsp;
                          {{ order_job.rel_order_position.reports_to_contact.work_email }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- ACCOUNTS CONTACT -->
                  <div class="col-xl-6">
                    <div class="ind_contact">
                      <h5 class="contact_header">ACC</h5>
                      <div class="ind_contact_details">
                        <p class="mb-0 pl-2 pt-0">
                          <span style="font-weight: bold; font-size: 0.8rem;"
                            v-if="order_job.order.accounts_contact !== null">
                            {{ order_job.order.accounts_contact.person.first_name }} {{
                              order_job.order.accounts_contact.person.surname }}
                          </span>
                        </p>
                        <p class="mb-0 pl-2 pt-1" style="line-height: 15px;">
                          <span v-if="order_job.order.accounts_contact.work_landline !== null">
                            <i class="fas fa-phone-alt bp_color"></i>&nbsp; {{
                              order_job.order.accounts_contact.work_landline }}
                          </span>
                          <span v-if="order_job.order.accounts_contact.work_mobile !== null">
                            <i class="fas fa-mobile-alt bp_color"></i>&nbsp; {{
                              order_job.order.accounts_contact.work_mobile }}
                          </span>
                        </p>
                        <p class="mb-0 pl-2 pt-1" style="line-height: 15px;"><i class="fas fa-at bp_color"></i>&nbsp; {{
                          order_job.order.accounts_contact.work_email }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- TERMS CONTACT -->
                  <div class="col-xl-6">
                    <div class="ind_contact">
                      <h5 class="contact_header">TERMS</h5>
                      <div class="ind_contact_details">
                        <p class="mb-0 pl-2 pt-0">
                          <span style="font-weight: bold; font-size: 0.8rem;"
                            v-if="order_job.order.authorise_terms_contact !== null">
                            {{ order_job.order.authorise_terms_contact.person.first_name }} {{
                              order_job.order.authorise_terms_contact.person.surname }}
                          </span>
                        </p>
                        <p class="mb-0 pl-2 pt-1" style="line-height: 15px;">
                          <span v-if="order_job.order.authorise_terms_contact.work_landline !== null">
                            <i class="fas fa-phone-alt bp_color"></i>&nbsp; {{
                              order_job.order.authorise_terms_contact.work_landline }}
                          </span>
                          <span v-if="order_job.order.authorise_terms_contact.work_mobile !== null">
                            <i class="fas fa-mobile-alt bp_color"></i>&nbsp; {{
                              order_job.order.authorise_terms_contact.work_mobile }}
                          </span>
                        </p>
                        <p class="mb-0 pl-2 pt-1" style="line-height: 15px;"><i class="fas fa-at bp_color"></i>&nbsp; {{
                          order_job.order.authorise_terms_contact.work_email }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </b-tab>
        <!-- Assignments -->
        <b-tab title="Assignments" lazy>
          <order_assignments :order="order_job" :current_assignments="current_assignments"
            :historic_assignments="historic_assignments"></order_assignments>
        </b-tab>
        <!-- Timesheet Authorisation -->
        <b-tab title="Timesheet Authorisation" lazy>
          <timesheet_auth :order_job="order_job" :default_timesheet_auth="order_job.timesheet_authorisations"
            :contacts="contacts" :company="order_job.order.company"></timesheet_auth>
        </b-tab>
        <!-- Position Details -->
        <b-tab title="Position Details" lazy>
          <position_details :order_job="order_job"></position_details>
        </b-tab>
        <!-- Accounts & Terms Info -->
        <b-tab title="Accounts & Terms Info" lazy>
          <!--      Accounts/Invoicing-->
          <div class="row">
            <div class="col-12">
              <b-card header="Accounts/Invoicing" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
                <div class="row">
                  <!-- Invoice Address -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="invoice_address">Invoice Address</label>
                    <p id="invoice_address">{{ order_job.order.invoice_address.full }}</p>
                  </div>
                  <!-- Payment Terms (Days from Invoice) -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="payment_terms">Payment Terms (Days from Invoice)</label>
                    <p id="payment_terms">{{ order_job.order.days_to_pay_from_invoice }} Days</p>
                  </div>
                </div>
              </b-card>
            </div>
          </div>

          <!-- MOO -->
          <div class="row" v-if="order_job.order.order_type === 'Contract' && order_job.rel_order_moo !== null">
            <div class="col-12">
              <b-card header="Mutuality of Obligation" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
                <div class="row">
                  <div class="col-xl-10">
                    <p class="cardLabel pt-0">Is the worker subject to any supervision, direction or control?</p>
                  </div>
                  <div class="col-xl-2">
                    <p class="cardLabel pt-0 font-weight-bold">
                      <span v-if="order_job.rel_order_moo.subject_to_sdc">Yes</span>
                      <span v-if="!order_job.rel_order_moo.subject_to_sdc">No</span>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-10">
                    <p class="cardLabel pt-0">Can the worker decline the request to be moved from job to job?</p>
                  </div>
                  <div class="col-xl-2">
                    <p class="cardLabel pt-0 font-weight-bold">
                      <span v-if="order_job.rel_order_moo.worker_decline_job_movement">Yes</span>
                      <span v-if="!order_job.rel_order_moo.worker_decline_job_movement">No</span>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-10">
                    <p class="cardLabel pt-0">Once this contract is completed are you (the end user) under any
                      obligation
                      to offer further work?</p>
                  </div>
                  <div class="col-xl-2">
                    <p class="cardLabel pt-0 font-weight-bold">
                      <span v-if="order_job.rel_order_moo.end_user_offer_further_work">Yes</span>
                      <span v-if="!order_job.rel_order_moo.end_user_offer_further_work">No</span>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-10">
                    <p class="cardLabel pt-0">Once this contract is completed is the worker under any obligation to
                      accept
                      additional work offered?</p>
                  </div>
                  <div class="col-xl-2">
                    <p class="cardLabel pt-0 font-weight-bold">
                      <span v-if="order_job.rel_order_moo.worker_accept_further_work">Yes</span>
                      <span v-if="!order_job.rel_order_moo.worker_accept_further_work">No</span>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-10">
                    <p class="cardLabel pt-0">Does the worker have the freedom to choose how the work is to be
                      performed?
                    </p>
                  </div>
                  <div class="col-xl-2">
                    <p class="cardLabel pt-0 font-weight-bold">
                      <span v-if="order_job.rel_order_moo.worker_choose_how_work_performed">Yes</span>
                      <span v-if="!order_job.rel_order_moo.worker_choose_how_work_performed">No</span>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-10">
                    <p class="cardLabel pt-0">Is the worker responsible for the standard of their own work?</p>
                  </div>
                  <div class="col-xl-2">
                    <p class="cardLabel pt-0 font-weight-bold">
                      <span v-if="order_job.rel_order_moo.worker_responsible_for_work">Yes</span>
                      <span v-if="!order_job.rel_order_moo.worker_responsible_for_work">No</span>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-10">
                    <p class="cardLabel pt-0">Does the worker carry financial risk in relation to any work completed?
                      (Especially substandard work)</p>
                  </div>
                  <div class="col-xl-2">
                    <p class="cardLabel pt-0 font-weight-bold">
                      <span v-if="order_job.rel_order_moo.worker_carry_financial_risk">Yes</span>
                      <span v-if="!order_job.rel_order_moo.worker_carry_financial_risk">No</span>
                    </p>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
          <!-- DRCE -->
          <div class="row" v-if="order_job.rel_order_position.drce_required && order_job.rel_order_drce !== null">
            <div class="col-12">
              <b-card header="DIRECT RECRUIT / COMPARABLE EMPLOYEE" header-tag="h4"
                body-class="mb-3 pb-2 record_card_body">
                <div class="row">
                  <div class="col-xl-8">
                    <p class="cardLabel pt-0">Does the Job Title and/or Job Duties exist already within the company? And
                      Does the temp role within this order also have the
                      potential to
                      last 12 weeks or longer?</p>
                  </div>
                  <div class="col-xl-4">
                    <p class="cardLabel pt-0 font-weight-bold">
                      <span v-if="order_job.rel_order_position.drce_required">Yes</span>
                      <span v-if="!order_job.rel_order_position.drce_required">No</span>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <!-- Basic Salary (£) -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="drce_basic_salary">Basic Salary (£)</label>
                    <p id="drce_basic_salary">{{ order_job.rel_order_drce.basic_salary }}</p>
                  </div>
                  <!-- Basic Hours -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="drce_basic_hours">Basic Hours</label>
                    <p id="drce_basic_hours">{{ order_job.rel_order_drce.basic_hours }}</p>
                  </div>
                  <!-- Rest Periods -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="drce_rest_periods">Rest Periods</label>
                    <p id="drce_rest_periods">{{ order_job.rel_order_drce.rest_periods }}</p>
                  </div>
                  <!-- Lunch Break -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="drce_lunch_break">Lunch Break</label>
                    <p id="drce_lunch_break">{{ order_job.rel_order_drce.lunch_break }}</p>
                  </div>
                  <!-- Overtime Payments -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="drce_overtime_payments">Overtime Payments</label>
                    <p id="drce_overtime_payments">{{ order_job.rel_order_drce.overtime_payments }}</p>
                  </div>
                  <!-- Shift Allowance -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="drce_shift_allowance">Shift Allowance</label>
                    <p id="drce_shift_allowance">{{ order_job.rel_order_drce.shift_allowance }}</p>
                  </div>
                  <!-- Commission -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="drce_commission">Commission</label>
                    <p id="drce_commission">{{ order_job.rel_order_drce.commission }}</p>
                  </div>
                  <!-- Annual Leave Entitlement -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="drce_annual_leave_entitlement">Annual Leave Entitlement</label>
                    <p id="drce_annual_leave_entitlement">{{ order_job.rel_order_drce.annual_leave_entitlement }}</p>
                  </div>
                  <!-- Monetary Benefits -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="drce_monetary_benefits">Monetary Benefits</label>
                    <p id="drce_monetary_benefits">{{ order_job.rel_order_drce.monetary_benefits }}</p>
                  </div>
                  <!-- Pension Contribution -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="drce_pension_contribution">Pension Contribution</label>
                    <p id="drce_pension_contribution">{{ order_job.rel_order_drce.pension_contribution }}</p>
                  </div>
                  <!-- Facilities -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="drce_facilities">Facilities</label>
                    <p id="drce_facilities">{{ order_job.rel_order_drce.facilities }}</p>
                  </div>
                </div>
              </b-card>
            </div>
          </div>

          <!-- TERMS OF BUSINESS -->
          <div class="row">
            <div class="col-12">
              <b-card header="TERMS OF BUSINESS" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
                <div class="row">
                  <!-- Client Ref/PO -->
                  <div class="col-xl-3 form-group">
                    <label class="form-label" for="client_ref_po">Client PO/Ref</label>
                    <p id="client_ref_po">{{ order_job.client_po_ref }}</p>
                  </div>
                  <!-- Amendments to Terms -->
                  <div class="col-xl-9 form-group">
                    <label class="form-label" for="amendments_to_terms">Amendments to Terms</label>
                    <pre id="amendments_to_terms">{{ order_job.amendments_to_terms }}</pre>
                  </div>
                </div>

              </b-card>
            </div>
          </div>

          <!-- ORDER DECLARATIONS -->
          <div class="row">
            <div class="col-12">
              <b-card header="ORDER DECLARATIONS" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
                <div class="mb-3">
                  <button type="button" class="btn btn-primary text-white" @click="addRamForm()"><i
                      class="fas fa-plus-circle"></i> Add Declaration</button>
                </div>
                <div v-for="(declaration, index) in declarations">
                  <Ram :data="declaration" @remove-ram="() => removeRam(index)"></Ram>
                </div>
              </b-card>
            </div>
          </div>

        </b-tab>
        <!-- Website Publish -->
        <b-tab title="Website Publish" lazy>
          <div class="row">
            <div class="col-12">
              <b-card header="Website Publish" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
                <div class="row" v-if="!edit_publish_info">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="cardLabel pt-0 font-weight-bold">Is this job published on the website?</p>
                      </div>
                      <div class="col-md-4">
                        <span v-if="e_publish_info.order_published" class="cardLabel">Yes</span>
                        <span v-if="!e_publish_info.order_published" class="cardLabel">No</span>
                      </div>
                    </div>
                    <div class="row" v-if="e_publish_info.order_published">
                      <div class="col-12">
                        <hr class="mt-1">
                      </div>
                      <div class="col-12">
                        <h5 class="bp_color">Published Text</h5>
                      </div>
                      <div class="col-12">
                        <div v-html="e_publish_info.publish_text"></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mb-1 text-right">
                    <button @click="edit_publish_info_show" class="btn orcaBtn blueBtn sm_btn">Edit Published
                      Status</button>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col-12">
                    <ValidationObserver ref="updatePublishInfo" slim>
                      <form role="form" @submit.prevent="update_publish_info_submit">
                        <div class="row">
                          <div class="col-12">
                            <div class="row">
                              <label class="col-xl-8 cardLabel font-weight-bold" style="font-size: 0.8rem;"
                                for="epi_order_published">Publish Position on Website</label>
                              <div class="col-xl-4">
                                <bootstrap-toggle v-model="e_publish_info.order_published" name="epi_order_published"
                                  id="epi_order_published" :options="{ on: 'Yes', off: 'No' }" />
                              </div>
                            </div>
                            <div class="row" v-if="e_publish_info.order_published">
                              <div class="col-xl-12 form-group">
                                <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Publish Content"
                                  tag="div">
                                  <label class="form-label" for="epi_publish_test">Publish Content</label>
                                  <Editor v-model="e_publish_info.publish_text" id="epi_publish_test"
                                    api-key="hyqedeskz2k2mylsbkhi8wjlpkdjapoxf0a038m8402qv96x" :init="{
                                      height: 500,
                                      menubar: false,
                                      plugins: 'advlist autolink lists link image charmap print preview anchor textcolor colorpicker code paste',
                                      toolbar: 'undo redo | formatselect | fontselect fontsizeselect | bold italic underline strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code',
                                      fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
                                      font_formats: 'Montserrat=sans-serif,Montserrat; Arial=arial,helvetica,sans-serif; Courier New=courier new,courier,monospace; Georgia=georgia,palatino,serif; Times New Roman=times new roman,times,serif; Verdana=verdana,geneva,sans-serif',
                                      paste_preprocess: pastePreprocess
                                    }" />


                                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
                        <div class="row">
                          <div class="col-xl-6">
                            <button @click.prevent="cancel_edit_form('updatePublishInfo')"
                              class="btn orcaBtn grey_bg">Cancel</button>
                          </div>
                          <div class="col-xl-6">
                            <button type="submit" class="btn orcaBtn">Update</button>
                          </div>
                        </div>
                      </form>
                    </ValidationObserver>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </b-tab>
        <!-- Idibu -->
        <b-tab title="Idibu" lazy disabled>
          <!--     id-->
        </b-tab>
        <!-- Notes -->
        <b-tab title="Notes" lazy>
          <b-card header="Notes" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
            <order_notes :notes="notes" :notesLoaded="notes_loaded"></order_notes>
          </b-card>
        </b-tab>
        <!-- Files -->
        <b-tab title="Documents" lazy>
          <b-card-text>
            <documents :files="files" :filesLoaded="files_loaded"></documents>
          </b-card-text>
        </b-tab>
        <!-- Activity on Order -->
        <b-tab title="Activity on Order" lazy v-if="canViewLogs()">
          <logs :logs="activity" :logsLoaded="activity_loaded"></logs>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
import BootstrapToggle from 'vue-bootstrap-toggle';
import Ram from 'resources/components/pages/orders/ram.vue';
import position_details from "pages/orders/order/position_details";
import order_notes from "pages/orders/order/order_notes";
import Documents from "pages/orders/order/documents";
import timesheet_auth from "pages/orders/order/timesheet_auth";
import order_assignments from "pages/orders/order/order_assignments";
import Datepicker from 'vuejs-datepicker';

import Editor from '@tinymce/tinymce-vue';
import logs from "./order/logs.vue";

export default {
  name: "view_order",
  components: {
    logs,
    loadingCube,
    BootstrapToggle,
    position_details,
    order_notes,
    Documents,
    timesheet_auth,
    order_assignments,
    Datepicker,
    Editor,
    Ram
  },
  data() {
    return {
      loading_order: true,
      order_tabIndex: this.$store.state.orders.current_order_tab_index,

      order_job: null,
      declarations: {},
      notes_loaded: false,
      notes: {},
      files_loaded: false,
      files: {},
      files_uploaded: [],
      // file_order: ['job_spec'],
      file_order: [],
      geotech: null,
      reverse_charge: null,

      extendingCcoDates: false,
      extendCcoDate: this.$moment.utc(new Date()).format("YYYY-MM-DD"),

      expandingCcoCapacity: false,
      expandCcoCapcityNumber: 0,

      assignments_loaded: false,
      current_assignments: [],
      historic_assignments: [],

      activity_loaded: false,
      activity: {},

      edit_publish_info: false,
      e_publish_info: {
        order_published: false,
        publish_text: '',
      },
      contacts: [],
      resending: false
    }
  },
  async beforeMount() {
    this.loading_order = true;

    await this.get_order();

    if (!this.order_job) {
      this.loading_order = false;
      return;
    }

    await this.get_order_job_files();
    await this.getDeclarations();
    this.loading_order = false;
  },
  computed: {
    file_reload() {
      return this.$store.state.files.reload_files;
    },
    note_reload() {
      return this.$store.state.notes.reload_notes;
    },
    assignment_reload() {
      return this.$store.state.assignments.reload_assignments;
    },
    activity_reload() {
      return this.$store.state.logs.reload_logs;
    },
    check_expiring() {
      let end_date = this.$moment.utc(this.order_job.rel_order_position.end_date);
      let end_date_14_days_before = this.$moment.utc(this.order_job.rel_order_position.end_date).subtract(14, 'days');
      // is after end date
      if (this.$moment.utc().isAfter(end_date)) {
        return 'expired'
      }
      else if (this.$moment.utc().isAfter(end_date_14_days_before)) {
        return 'expiring'
      }
      else {
        return ''
      }
    },
    default_ts_auth_reload() {
      return this.$store.state.timesheets.reload_default_client_ts_auth;
    }
  },
  watch: {
    geotech(newState, oldState) {
      if (oldState !== null) {
        this.updateGeotech(newState);
      }
    },
    reverse_charge(newState, oldState) {
      if (oldState !== null) {
        this.updateReverseCharge(newState);
      }
    },
    note_reload(val) {
      if (val === true) {
        this.notes_loaded = false;
        this.get_order_job_notes();
      }
    },
    file_reload(val) {
      if (val === true) {
        this.files_loaded = false;
        this.files_uploaded = [];
        this.get_order_job_files()
      }
    },
    activity_reload(val) {
      if (val === true) {
        this.activity_loaded = false;
        // this.get_worker_logs()
      }
    },
    order_tabIndex(tab) {
      this.$store.commit('SET_ORDER_TAB_INDEX', tab);
    },
    'e_publish_info.order_published'(val) {
      if (val) {
        if (this.order_job.rel_order_publish_info && this.order_job.rel_order_publish_info.publish_text != null) {
          this.e_publish_info.publish_text = this.order_job.rel_order_publish_info.publish_text
        }
        else {
          this.e_publish_info.publish_text =
            'Our client is looking for a ' + this.order_job.rel_order_position.job_title +
            ' to work at a location in ' + this.order_job.rel_order_location.job_address_city_town + '<br><br>' +
            'Essential Qualifications required for the position include:' +
            ''
        }
      }
      else {
        this.e_publish_info.publish_text = '';
      }
    },
    default_ts_auth_reload(val) {
      if (val) {
        this.get_order_timesheet_auth();
      }
    },
    assignment_reload(val) {
      if (val) {
        this.get_current_assignments();
        this.get_historic_assignments();
      }
    },
  },
  methods: {
    canViewLogs(){
      return this.$store.state.auth.me.permissions.includes('sunset_note_stats_restricted');
    },
    show_project_managed_fields() {
      return this.order_job.order.order_gm_solution === 'Project Managed Labour Solutions';
    },
    async get_order() {
      let orderId = this.$store.state.orders.current_order_id;
      if (!orderId) {
        return;
      }

      if(this.canViewLogs()){
        await this.get_order_logs();
      }

      await axios.get(this.crmApiPath + 'order/job/' + this.$store.state.orders.current_order_id).then(async order_job => {
        this.order_job = order_job.data;
        this.geotech = Boolean(this.order_job.geotech_enabled);
        this.reverse_charge = Boolean(this.order_job.rel_order_location.reverse_charge);
        this.e_publish_info.order_published = false;
        this.e_publish_info.publish_text = '';

        if (order_job.data.rel_order_publish_info) {
          this.e_publish_info.order_published = order_job.data.rel_order_publish_info.order_published;
          this.e_publish_info.publish_text = order_job.data.rel_order_publish_info.publish_text;
        }

        this.get_order_job_notes().then(() => {
          this.get_current_assignments().then(() => {
            this.get_historic_assignments().then(() => {
              this.expandCcoCapcityNumber = order_job.data.workers_required
            });
          });
        });
        await axios.get(this.crmApiPath + 'contact/company/' + this.order_job.order.company.id).then(client_contacts => {
          this.contacts = client_contacts.data;
        })
      });
    },
    async getDeclarations() {
      await axios.get(this.crmApiPathV2 + 'common/declarations/order/jobs/' + this.$store.state.orders.current_order_id).then(declarations => {
        this.declarations = declarations.data.data;
      })
    },
    removeRam(index) {
      this.declarations.splice(index, 1);
    },
    addRamForm() {
      const ram = {
        order_job_id: this.$store.state.orders.current_order_id,
        title: null,
        description: null,
        company_required: true,
        worker_required: true,
        link: null,
        file: null
      };

      this.declarations.push(ram);
    },
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    extend_cco_date() {
      this.extendingCcoDates = true;
      let self = this;

      axios.post(this.crmApiPath + 'order/job/extend', {
        orderJobId: self.$store.state.orders.current_order_id,
        date: self.extendCcoDate
      }).then(function () {
        self.extendingCcoDates = false;
        self.$tabs.refresh('/order/view', true);
      });
    },
    resendOrder() {

      if (this.resending) {
        this.$snotify.warning('Email is already sending. Please wait.');
        return;
      }

      this.resending = true;
      let id = this.$store.state.orders.current_order_id;

      if (!this.order_job.order.job_contact) {
        this.$snotify.error('No JOB contact to send the order');
      }

      let payload = {
        order_id: id,
        status: 'Live',
        consultant_name: this.order_job.order.consultant.first_name,
        contact_first_name: this.order_job.order.job_contact.person.first_name,
        contact_surname: this.order_job.order.job_contact.person.surname,
        contact_email: this.order_job.order.job_contact.work_email
      };

      axios.post(this.crmApiPath + 'order/send_order_email', payload).then(() => {
        this.$snotify.success('Order has been sent to the client');
        this.resending = false;
      });
    },
    updateGeotech(state) {
      let notify = this.$snotify;
      axios.post(this.crmApiPath + 'order/job/geotech', {
        order_job_id: this.order_job.id,
        state: state
      }).then(function (data) {
        if (data.data.code === "OK") {
          notify.success('Geotech updated');
        } else {
          notify.error(data.data.error);
        }
      });
    },
    updateReverseCharge(state) {
      let notify = this.$snotify;
      axios.post(this.crmApiPath + 'order/job/reverse_charge', {
        order_job_id: this.order_job.id,
        state: state
      }).then(function (data) {
        if (data.data.code === "OK") {
          notify.success('Reverse charge has been updated');
        } else {
          notify.error(data.data.error);
        }
      });
    },
    extend_cco_capacity() {
      this.$refs.extendCcoWorkersForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.extendCcoWorkersForm);
        }
        else {
          this.expandingCcoCapacity = true
          let self = this;
          axios.post(this.crmApiPath + 'order/job/expand_capacity', {
            order_job_id: self.order_job.id,
            workers_required: self.expandCcoCapcityNumber
          }).then(function () {
            self.expandingCcoCapacity = false;
            self.$tabs.refresh('/order/view', true);
          });
        }
      });

    },

    async get_order_logs() {
      return await axios.get(this.crmApiPath + 'sunset/logs/order/' + this.$store.state.orders.current_order_id).then(activity => {
        this.activity = activity.data;
        this.activity_loaded = true;
      })
    },

    async get_order_job_notes() {
      return await axios.get(this.crmApiPath + 'note/order_job/' + this.$store.state.orders.current_order_id).then(order_job => {
        this.notes = order_job.data;
        this.notes_loaded = true;
      });
    },
    async get_order_job_files() {
      this.files_loaded = true;
      return null; // this API end point currently does nothing
      // return axios.get(this.crmApiPath + 'file/order_job/' + this.$store.state.orders.current_order_id).then(order_job_files => {
      //
      //   if(!order_job_files.data) {
      //     return null;
      //   }
      //
      //   this.files = this.mapArrayOrder(order_job_files.data, this.file_order, 'type');
      //   this.files.sort(function (a, b) {
      //     let file_a = a.type.file_type.toLowerCase(), file_b = b.type.file_type.toLowerCase();
      //     if (file_a < file_b) {
      //       return -1
      //     }
      //     if (file_a > file_b) {
      //       return 1
      //     }
      //   });
      //
      //   this.files_loaded = true;
      //   this.$nextTick(() => order_job_files.data.forEach(file => this.files_uploaded.push(file.type.id)));
      // });
    },
    get_order_timesheet_auth() {
      let order_company_id = this.order_job.order.company_id,
        order_job_id = this.order_job.id
      // if the order has default timesheet authorisation set
      if (this.order_job.default_ts_auth) {
        axios.get(this.crmApiPath + 'timesheet_authorisation/client/get/' + order_company_id)
          .then(ts_auth => {
            // set company default timesheet authorisers to returned data
            this.order_job.timesheet_authorisations = ts_auth.data
          })
      }
      // else order specific timesheet authorisation
      else {
        axios.get(this.crmApiPath + 'timesheet_authorisation/order_job/get/' + order_job_id)
          .then(ts_auth => {
            this.order_job.timesheet_authorisations = ts_auth.data
          })
      }
    },

    createEmail() {

    },
    createEvent() {

    },
    createTask() {

    },
    delete_order() {

    },
    pastePreprocess(plugin, args) {
      args.content = args.content
        .replace(/[\u2018\u2019]/g, "'")     // smart single quotes → '
        .replace(/[\u201C\u201D]/g, '"')     // smart double quotes → "
        .replace(/\u00A0/g, ' ')             // non-breaking space → space
        .replace(/…/g, '...')                // ellipsis → ...
        .replace(/[^\x20-\x7E\n\r]/g, '');   // remove non-printable ASCII
    },
    copy_order() {
      this.$store.commit('COPY_ORDER_JOB_ID', this.order_job.id);
      this.$nextTick(() => {
        this.$tabs.refresh('/order/copy', true)
        this.$router.push('/order/copy');
      });
    },
    end_order() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Ending this Order!</div>' +
          '<div class="snotifyToast__body">' +
          'Are you sure that you want to<br><strong class="red_color">Unassign All Workers</strong><br>and<br><strong class="red_color">End ' + this.order_job.order_ref +
          '</strong>' +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '</div>',
        buttons: [
          {
            text: 'End Order', action: (toast) => {
              this.$snotify.remove(toast.id);
              this.$snotify.confirm('', '', {
                closeOnClick: false,
                position: 'centerCenter',
                backdrop: 0.5,
                html: '<div class="snotifyToast__title">Are you sure!</div>' +
                  '<div class="snotifyToast__body">' +
                  '<strong class="text-uppercase">This cannot be undone.</strong><br>Are you sure you want to<br><strong class="red_color">Unassign All Workers</strong><br>and' +
                  '<br><strong class="red_color">End ' + this.order_job.order_ref + '</strong>' +
                  '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
                  '</div>',
                buttons: [
                  {
                    text: 'Confirm End Order', action: (toast) => {
                      this.$snotify.remove(toast.id);
                      axios.post(this.crmApiPath + 'order/job/end_and_unassign/' + this.order_job.id, {
                        'log_by_id': this.$store.state.auth.me.id,
                        order_progress: {
                          'order_job_id': this.order_job.id,
                          'order_progress_status': 'Ended'
                        },
                        assignments: {
                          'order_job_id': this.order_job.id
                        }
                      }).then(res => {
                        // console.log('done')
                        // this.$bus.$emit('assignments::reload', {action: true});
                        axios.get(this.crmApiPath + 'order/job/' + this.$store.state.orders.current_order_id).then(order_job => {
                          this.order_job = order_job.data;
                          this.e_publish_info.order_published = false;
                          this.e_publish_info.publish_text = '';

                          if (order_job.data.rel_order_publish_info) {
                            this.e_publish_info.publish_text = order_job.data.rel_order_publish_info.publish_text;
                            this.e_publish_info.order_published = order_job.data.rel_order_publish_info.order_published;
                          }

                          this.loading_order = true;
                          // this.get_order_notes().then(() => {
                          this.get_current_assignments().then(() => {
                            this.get_historic_assignments().then(() => {

                            });
                          });

                          // });
                          axios.get(this.crmApiPath + 'contact/company/' + this.order_job.order.company.id).then(client_contacts => {
                            this.contacts = client_contacts.data;
                          })

                          this.loading_order = false;
                        });

                      })
                    }
                  },
                  { text: 'Cancel', action: (toast) => this.$snotify.remove(toast.id) }
                ]
              })
            }
          },
          { text: 'Cancel', action: (toast) => this.$snotify.remove(toast.id) }
        ]
      })
    },
    add_note_modal() {
      this.$store.commit('SHOW_ADD_NOTE_MODAL', {
        id: this.order_job.id,
        name: this.order_job.order_ref,
        type: 'order_job',
        contacts: null
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_note_modal'));
    },
    add_files_modal() {
      this.$store.commit('SHOW_ADD_FILE_MODAL', {
        id: this.order_job.id,
        name: this.order_job.order_ref,
        // employment_type: this.worker.rel_company_info.employment_type,
        type: 'order_job',
        // vat_registered: this.worker.rel_company_info.vat_registered,
        uploaded_files: this.files_uploaded,
        // nationality: this.worker.person.nationality,
      });
      this.$store.state.files.add_modal = true;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'upload_file_modal'));
    },

    get_current_assignments() {
      return axios.get(this.crmApiPath + 'assignments/order_job/current_assignments/' + this.order_job.id).then(curr_ass => {
        this.current_assignments = curr_ass.data;
      })
    },
    get_historic_assignments() {
      return axios.get(this.crmApiPath + 'assignments/order_job/historic_assignments/' + this.order_job.id).then(hist_ass => {
        this.historic_assignments = hist_ass.data;
      })
    },

    edit_publish_info_show() {
      this.edit_publish_info = true;
    },
    update_publish_info_submit() {

      this.$refs.updatePublishInfo.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.updatePublishInfo);
          return;
        }

        this.loading_order = true;
        let promise;
        let pub_order = {
          order_job_id: this.order_job.id,
          order_published: this.e_publish_info.order_published,
          publish_text: this.e_publish_info.publish_text,
          log_by_type: 'App\\Models\\Users\\User',
          log_by_id: this.$store.state.auth.me.id
        };

        if (!this.order_job.rel_order_publish_info) {
          promise = axios.post(this.crmApiPath + 'order/publish_info', pub_order);
        } else {
          promise = axios.patch(this.crmApiPath + 'order/publish_info/' + this.order_job.rel_order_publish_info.id, pub_order);
        }

        promise.then(() => {
          this.edit_publish_info = false;

          this.get_order();
        })
        this.loading_order = false;
      });

    },
    cancel_edit_form(form) {
      if (form === 'updatePublishInfo') {

        this.edit_publish_info = false;
        // restore previously saved data
        this.e_publish_info.order_published = this.order_job.rel_order_publish_info.order_published;
        this.e_publish_info.publish_text = this.order_job.rel_order_publish_info.publish_text;

      }
    }
  }
}
</script>

<style scoped lang="scss">
.ind_contact {
  position: relative;
  display: block;
  border-radius: $border_radius_2;
  padding-top: 2px;
  padding-bottom: 5px;
  border: solid 2px $bc_3;
  border-left: 20px $bc_3 solid;
  margin-bottom: 15px;

  .contact_header {
    font-weight: bold;
    font-size: 0.68rem;
    color: $white;
    text-transform: uppercase;
    position: absolute;
    top: 7px;
    right: 0;
    left: -4px;
    margin-bottom: 0;
    transform-origin: top left;
    transform: rotate(90deg);
    height: 15px;
    width: 50px;
  }

  .ind_contact_details {
    /*width: 200px;*/
  }

  .contact_label {
    display: inline-block;
    width: 65px;
  }
}

.order_signed,
.order_unsigned,
.expired,
.expiring,
.order_ended {
  color: $white;
  text-align: center;
  text-transform: uppercase;
  line-height: 40px;
  font-weight: bold;
  border-radius: $border_radius_2;
}

.order_signed {
  background: $green;
}

.order_unsigned,
.expired,
.order_ended {
  background: $red;
}

.expiring {
  background: $orange;
}

pre {
  font-family: $font-family-paragraph;
  margin-bottom: 0;
  margin-top: 0;
  font-size: 0.8rem;
  padding-top: 12px;
}
</style>
